import * as React from "react";
import { memo } from "react";
const SvgCaretRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 23 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.12891 5.01562L15.9618 11.8485L9.12891 18.6813", stroke: "white", strokeWidth: 2.18651, strokeLinecap: "round", strokeLinejoin: "round" }));
const Memo = memo(SvgCaretRight);
export default Memo;
